var map = {
	"./cs.json": 9789,
	"./de.json": 9929,
	"./en.json": 790,
	"./es.json": 8563,
	"./hun.json": 6024,
	"./id_ID.json": 1180,
	"./it.json": 504,
	"./ja.json": 8566,
	"./nb_NO.json": 5978,
	"./nl.json": 3055,
	"./pl.json": 5143,
	"./pt_BR.json": 5321,
	"./ru.json": 9672,
	"./sk.json": 1941,
	"./uk.json": 1754,
	"./zh_Hans.json": 4709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1845;